<forge-card *ngIf="hasChecks" class="no-padding">
    <forge-toolbar>
        <h2 class="forge-typography--heading4" slot="start">In Balance</h2>
    </forge-toolbar>

    <div *ngIf="loaded">
        <div *ngFor="let provider of sortedProviders; let i=index">
            <in-balance-check [index]="i" [provider]="provider.ProviderId"></in-balance-check>
        </div>
    </div>
</forge-card>
